
<div  *ngIf="type=='normal'; else fixed">


<div class="user-button-container" #userButton>

  <button mat-button fxHide.lt-md class="user-button" color="none"
   [matMenuTriggerFor]="accountMenu"
    #accountMenuTrigger="matMenuTrigger">
    <span fxLayout="row" fxLayoutAlign="start center">
      <span class="avatar-container" fxLayout="row" fxLayoutAlign="start center">
        <mat-icon [ngStyle]="{'color':color=='white' ? 'black' : 'White' }"> account_circle</mat-icon>
        <i class="status "></i>
      </span>

      <div  *ngIf="displayNameFully">
        <span [ngStyle]="{'color':color=='white' ? 'black' : 'White' }"
         class="name" fxHide fxShow.gt-sm fxShow.gt-sm>Hi {{username}}</span>
      </div>

      <div *ngIf="!displayNameFully">
        <span [ngStyle]="{'color':color=='white' ? 'black' : 'White' }" fxHide fxShow.gt-sm fxShow.gt-sm>&nbsp; ACCOUNT</span>
      </div>

      <mat-icon [ngStyle]="{'color':color=='white' ? 'black' : 'White' }" class="icon" fxHide fxShow.gt-sm fxShow.gt-sm>keyboard_arrow_down</mat-icon>
    </span>
  </button>
</div>

<mat-menu #accountMenu="matMenu" [overlapTrigger]="false" xPosition="before" class="calsoft-dropdown ">
  <span (mouseleave)="accountMenuTrigger.closeMenu()">
    <a mat-menu-item routerLink="/account/information">
      <mat-icon class="material-icons-outlined mat-icon-sm">settings</mat-icon>
      <span>Account Settings</span>
    </a> <a mat-menu-item routerLink="/orders">
      <mat-icon class="material-icons-outlined mat-icon-sm">
        receipt
      </mat-icon>
      <span>Your Orders</span>
    </a>
    <a mat-menu-item routerLink="/account/wishlist">
      <mat-icon class="material-icons-outlined mat-icon-sm">favorite</mat-icon>
      <span>Wishlist </span>
    </a>

    <div class="divider"></div>
    <a (click)="signOut()" mat-menu-item>
      <mat-icon class="material-icons-outlined mat-icon-sm">power_settings_new</mat-icon>
      <span>Sign Out</span>
    </a>
  </span>
</mat-menu> 
</div>

<ng-template #fixed>

<div  routerLink="/account/information" class="user-button-container" #userButton>
<button *ngIf="url!='/account/information'" mat-button fxHide.lt-md class="user-button">
<span fxLayout="row" fxLayoutAlign="start center">
  <span class="avatar-container" fxLayout="row" fxLayoutAlign="start center">
    <mat-icon [ngStyle]="{'color':color=='white' ? 'black' : 'White' }"> account_circle</mat-icon>
    <i class="status "></i>
  </span>
  <div *ngIf="displayNameFully">
    <span [ngStyle]="{'color':color=='white' ? 'black' : 'White' }" class="name" fxHide fxShow.gt-sm fxShow.gt-sm>Hi {{username}}</span>
  </div>

  
  <div *ngIf="!displayNameFully">
    <span [ngStyle]="{'color':color=='white' ? 'black' : 'White' }" class="name" fxHide fxShow.gt-sm fxShow.gt-sm>ACCOUNT</span>
  </div>
 
  <!-- <mat-icon class="icon" fxHide fxShow.gt-sm fxShow.gt-sm>keyboard_arrow_down</mat-icon> -->
</span>
</button>
</div>
</ng-template>